import script from "./PopUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopUp.vue?vue&type=script&lang=ts&setup=true"

import "./PopUp.vue?vue&type=style&index=0&id=b34e219e&lang=css"

const __exports__ = script;

export default __exports__